/* HUME HEALTH DE — Homepage Redesign · Core JS (lightweight, no deps)
   - Scroll reveal via IntersectionObserver
   - Count-up for [data-count] when revealed
   Performance-first: no smooth-scroll hijack, no particles. */
(function () {
  if (window.__hhCoreInit) return;
  window.__hhCoreInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var dec = (el.getAttribute('data-count').split('.')[1] || '').length;
    var dur = 1400, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = (target * eased);
      el.textContent = dec ? val.toFixed(dec).replace('.', ',') : Math.round(val).toLocaleString('de-DE');
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = dec ? target.toFixed(dec).replace('.', ',') : Math.round(target).toLocaleString('de-DE');
    }
    requestAnimationFrame(step);
  }

  function init() {
    var els = document.querySelectorAll('.hh-reveal, [data-count]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-count')) {
          var d = el.getAttribute('data-count');
          el.textContent = (d.indexOf('.') > -1) ? d.replace('.', ',') : parseInt(d, 10).toLocaleString('de-DE');
        }
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.hasAttribute('data-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
